import * as React from 'react';
import { ClusterIcon } from '@patternfly/react-icons';
import {
  Alert,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Content,
  ContentVariants,
  DescriptionList,
  DescriptionListDescription,
  DescriptionListGroup,
  DescriptionListTerm,
  Icon,
  PageBreadcrumb,
  PageSection,
  PageSectionVariants,
} from '@patternfly/react-core';
import { useAuth } from 'react-oidc-context';
import Unauthenticated from '@app/Unauthenticated';
import Overview from './Overview';
import { useClient } from '../../hooks/useClient';

function Datacenter() {
  const auth = useAuth();
  const { client } = useClient();

  if (!auth.isAuthenticated) {
    return <Unauthenticated />;
  }

  const organizationIdentifier = client?.netbox_owner_name;

  return (
    <>
      <PageBreadcrumb hasBodyWrapper={false} hasShadowBottom={false}>
        <Breadcrumb ouiaId="BasicBreadcrumb">
          <BreadcrumbItem isActive>Datacenter</BreadcrumbItem>
        </Breadcrumb>
      </PageBreadcrumb>
      <PageSection
        hasBodyWrapper
        type="default"
        variant={PageSectionVariants.default}
        isWidthLimited
        hasShadowBottom={true}
      >
        <Content component={ContentVariants.h2}>
          <Icon size="lg" style={{ marginRight: '8px' }}>
            <ClusterIcon />
          </Icon>
          Datacenter
        </Content>
        <Content component={ContentVariants.small}>Below is a recap of the resources you own</Content>
      </PageSection>

      <PageSection hasBodyWrapper={false} isWidthLimited>
        <Card isCompact>
          <CardTitle>Organization API Identifier</CardTitle>
          <CardBody>
            {organizationIdentifier ? (
              <DescriptionList isCompact isHorizontal>
                <DescriptionListGroup>
                  <DescriptionListTerm>Identifier</DescriptionListTerm>
                  <DescriptionListDescription>{organizationIdentifier}</DescriptionListDescription>
                </DescriptionListGroup>
              </DescriptionList>
            ) : (
              <Alert variant="warning" title="Organization not linked" isInline component="h4">
                Your organization does not have an identifier configured yet. This may limit access to infrastructure
                resources. If this persists, please contact support.
              </Alert>
            )}
          </CardBody>
        </Card>
      </PageSection>

      <PageSection hasBodyWrapper={false}>
        <Overview />
      </PageSection>
    </>
  );
}

export { Datacenter };
